// extracted by mini-css-extract-plugin
module.exports = {"Container":"BlockQuote_Container__35s5K"};